module.exports = __webpack_public_path__ + "static/media/069-british-indian-ocean-territory.78eaf332.svg";